import * as XLSX from "xlsx";
import { useIntl } from "react-intl";
import Messages from "../localization/Messages";
import { DateFormat, getDateText } from "../helpers/dateHelper";
import { useCallback } from "react";

type CsvHeaderKey = (typeof Messages)[keyof typeof Messages];

export function useCustomExportToXls() {
    const intl = useIntl();

    const downloadFn = useCallback(
        (
            columns: CsvHeaderKey[],
            values: string[][],
            additionalColumns?: string[],
            fileName?: string,
        ) => {
            const headerLabels = columns.map(message => intl.formatMessage(message));
            if (additionalColumns?.length) headerLabels.push(...additionalColumns);

            const localFileName =
                fileName?.replace(".csv", ".xlsx") ??
                `export-${getDateText(Date.now(), DateFormat.API_DATE)}.xlsx`;

            // Combine headers + data rows into a 2D array
            const worksheetData = [headerLabels, ...values];

            // Create worksheet and workbook
            const ws = XLSX.utils.aoa_to_sheet(worksheetData);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, "Statistics");

            // Write to file and trigger download
            XLSX.writeFile(wb, localFileName);
        },
        [intl],
    );

    return downloadFn;
}
